<template>
<div class="map-container">
    <div class="map"></div>
    <div id="mapChart" ref="mapChart" :style="{height:height,width:width,top:top}"></div>
	<div v-if="showAlert" class="alertInfo">
		<div class="name">{{nowAreaName}}</div>
		<div class="info" v-for="item in alertInfo">
			<span>{{item.type}}</span>
			<span>{{item.num}}</span>
		</div>
	</div>
</div>
</template>

<script>
import echarts from "echarts";

import AMap from "AMap";
import AMapUI from 'AMapUI';
import publicFn from '../../../assets/js/publicFn.js'
import {
    cloudApi
} from '../../../api-path/cloud-api.js'
//去除默认的鼠标事件
document.oncontextmenu = function () {
    return false;
};
export default {
    name: "mapChart",
    components: {},
    props: {
        markData: {
            type: [Object, Array],
            default: () => {}
        },
        queryParams: {
            type: [Object, Array],
            default: () => {}
        },
        width: {
            type: String,
            default: "100%"
        },
        height: {
            type: String,
            default: "100%"
        },
        isShow: {
            type: Boolean,
            default: true
        },
        count: {
            type: Number,
            default: 10000
        },
        areaId: {
            default: '10000'
        },
		type:{
			type:String,
			default:''
		}
    },

    data() {
        return {
            chart: null,
            cityName: "中国",
            areaCode: 10000,
            geoJsonData: "",
            echartsMap: null,
            map: null,
            district: null,
            // count: 0,
            opts: {},
            areaData: {},
            mapData: [],
            codeList: [],
            // markData: {}
            //MarksArray存放上级区域实现返回上级
            MarksArray: [],
            mapAreaId: '',
            top: '0px',
			//当前鼠标移入的区域
			nowCityCode:'',
			nowAreaName:'',
			alertInfo:[],
			showAlert:false
        };
    },
    mounted() {
        // 自适应
        window.addEventListener("resize", () => {
            if (this.chart) this.chart.resize();
        });
        let areaId = this.areaId;
        if (areaId === '0' || !areaId) {
            areaId = 10000;
            this.mapAreaId = areaId
        } else if (areaId.length < 6) {
            let len = 6 - areaId.length;
            let zero = '';
            for (let i = 0; i < len; i++) {
                zero += '0';
            }
            this.mapAreaId = areaId + zero;
            areaId = areaId + zero;
        } else {
            this.mapAreaId = areaId;
        }
    },
    watch: {
		areaId(val){
            if (val) {
				let areaId = val;
				if (areaId === '0' || !areaId) {
				    areaId = 10000;
				    this.mapAreaId = areaId
				} else if (areaId.length < 6) {
				    let len = 6 - areaId.length;
				    let zero = '';
				    for (let i = 0; i < len; i++) {
				        zero += '0';
				    }
				    this.mapAreaId = areaId + zero;
				    areaId = areaId + zero;
				} else {
				    this.mapAreaId = areaId;
				}
                this.$nextTick(function () {
                    this.initChart(this.mapAreaId, true);
                });
            }
		},
        markData(val) {
            if (val) {
                this.$nextTick(function () {
                    this.initChart(this.mapAreaId, true);
                });
            }
        },
		nowCityCode(val){
			if(val){
				let code=this.getAreaCode(this.nowCityCode,this.level);
				if(this.type=='alarm'){
					this.$http.get(cloudApi.alramTypeCount, {
						params: {
							areaId: code
						}
					}).then(res => {
						if (res.status == 200) {
							this.showAlert=true;
					        this.alertInfo = res.result
						}
					})
				}else if(this.type=='camera'){
					this.$http.get(cloudApi.cameraTypeCount, {
					    params: {
					        areaId: code
					    }
					}).then(res => {
					    if(res.status == 200) {
							this.showAlert=true;
					        this.alertInfo = res.result
					    }
					})
				}else{
					this.$http.get(cloudApi.userCountUserByType, {
						params: {
							areaId: code
						}
					}).then(res => {
						if (res.status == 200) {
							this.showAlert=true;
							this.alertInfo = res.result.map(item => {
								return {
									type: item.userTypeName,
									num: item.num
								}
							})
						}
					})
					
				}
			}
		}
    },
    methods: {
        initChart(adcode, region) {
            const $this = this;
            this.chart = echarts.init(this.$refs.mapChart);
            this.chart.on("click", this.chartClick);
            this.chart.on("contextmenu", this.chartDbClick);
			this.chart.on('mouseover',this.chartMoveIn);
			this.chart.on('mouseout',this.chartMoveOut);
            this.opts = {
                subdistrict: 1, //返回下一级行政区
                showbiz: false //最后一级返回街道信息
            };
            AMap.service('AMap.DistrictSearch', function () { //回调函数
                $this.district = new AMap.DistrictSearch($this.opts); //注意：需要使用插件同步下发功能才能这样直接使用
                $this.district.search(adcode, (status, result) => {
                    if (status == "complete") {
                        $this.getData(
                            result.districtList[0],
                            result.districtList[0].level,
                            result.districtList[0].adcode,
                            false,
                            region
                        );
                    }
                });
            })
        },

        getData(data, level, adcode, click, region) {
            let newCode = data.adcode;
            let result = this.MarksArray.find(item => item.adcode === newCode);
            if (!result) {
                this.MarksArray.push({
                    name: data.name,
                    level: data.level,
                    adcode: data.adcode,
                    level: data.level,
                    cityCode: data.citycode
                })
            }
            //重庆分为城区和郊区  需要合并数据
            if (data.adcode == "500100") {
                this.district.search("500200", (status, result) => {
                    if (status === "complete") {
                        subList = subList.concat(result.districtList[0].districtList);
                        this.mapData = [];
                        for (var i = 0, l = subList.length; i < l; i++) {
                            var name = subList[i].name;
                            var cityCode = subList[i].adcode;
                            this.mapData.push({
                                name: name,
                                cityCode: cityCode,
                                level: curlevel
                            });
                        }

                        this.loadMapData(adcode, "", level);
                        return;
                    }
                });
            }
            var subList = data.districtList;
            if (subList) {
                var curlevel = subList[0].level;
                if (curlevel === "street") {
                    if (region) {
                        this.loadMapData(adcode, region, level);
                    } else {
                        let mapJsonList = this.geoJsonData.features;
                        let mapJson = {};
                        for (let i in mapJsonList) {
                            if (mapJsonList[i].properties.name == this.cityName) {
                                mapJson.features = [].concat(mapJsonList[i]);
                            }
                        }
                        this.mapData = [];
                        this.mapData.push({
                            name: this.cityName,
                            cityCode: adcode,
                            level: curlevel
                        });
                        this.loadMap(this.cityName, mapJson, level);
                    }

                    // 改变下拉框
                    if (click) {
                        //区分是点击事件才执行，不然会与下拉框选择事件一起触发
                        let params = {
                            level: level,
                            adcode: adcode
                        };
						params.adcode = this.getAreaCode(params.adcode,params.level);
                        this.$emit("clickMap", params);
                    }
                    return;
                }
                this.mapData = [];
                for (var i = 0, l = subList.length; i < l; i++) {
                    var name = subList[i].name;
                    var cityCode = subList[i].adcode;
                    this.mapData.push({
                        name: name,
                        cityCode: cityCode,
                        level: curlevel
                    });
                }

                this.loadMapData(adcode, "", level);
                // 改变下拉框
                if (click) {
                    let params = {
                        level: level,
                        adcode: adcode
                    };
                    //去除0
                    params.adcode = this.getAreaCode(params.adcode,params.level);
                    this.$emit("clickMap", params);
                }
            }
        },
        loadMapData(areaCode, region, level) {
            AMapUI.loadUI(["geo/DistrictExplorer"], DistrictExplorer => {
                //创建一个实例
                var districtExplorer = (window.districtExplorer = new DistrictExplorer({
                    eventSupport: true, //打开事件支持
                    map: this.map
                }));
                //  行政区划浏览的直辖市等级为北京市=》朝阳区，并不是北京市=》北京城区=》朝阳区 所以需要转化
                if (areaCode == "110100") {
                    areaCode = "110000";
                } else if (areaCode == "120100") {
                    areaCode = "120000";
                } else if (areaCode == "500100" || areaCode == "500200") {
                    areaCode = "500000";
                } else if (areaCode == "310100") {
                    areaCode = "310000";
                }
                districtExplorer.loadAreaNode(areaCode, (error, areaNode) => {

                    if (error) {
                        console.log("报错啦");

                        return;
                    }
                    if (areaNode) {
                        // 次级页面直接显示区县 需要单独处理;
                        if (region) {
                            let mapJson = {
                                features: []
                            };
                            mapJson.features[0] = areaNode.getParentFeature();
                            this.loadMap(mapJson.features[0].properties.name, mapJson, level);
                            this.geoJsonData = mapJson;
                        } else {
                            let mapJson = {};
                            mapJson.features = areaNode.getSubFeatures();
                            this.loadMap(this.cityName, mapJson, level);
                            this.geoJsonData = mapJson;
                        }
                    }
                });
            });
        },
        loadMap(mapName, data, level) {
			const that=this;
			let dataInfoList=this.convertData(this.markData);
            let labelShow = level == "country" ? false : true;
            if (data) {
                this.$echarts.registerMap(mapName, data);
                var option = {
                    tooltip: {
                        show: false,
                        trigger: "item",
                        showContent: true,
                        alwaysShowContent: true,
                        formatter: "{b}"
                    },
                    series: [{
                        name: "数据名称",
                        type: "map",
                        bottom: "0%",
                        // aspectScale:1,
                        zoom: 2, //缩放
                        roam: false, //是否开启鼠标缩放和平移漫游
                        mapType: mapName,
                        // selectedMode: "single",
                        // showLegendSymbol: false,
                        visibility: "off",
                        itemStyle: {
                            normal: {
                                color: "#ccc",
                                areaColor: "#162756",
                                borderColor: "#131F4a",
                                borderWidth: 1,
                                label: {
                                    show: labelShow,
                                    textStyle: {
                                        color: "rgb(249, 249, 249,.5)"
                                    }
                                }
                            },
                            emphasis: {
                                areaColor: '#4c92db',
                                borderColor: "#4c92db",
                                areaStyle: {
                                    color: "#fff"
                                },
                                label: {
                                    show: true,
                                    textStyle: {
                                        color: "#fff"
                                    }
                                }
                            }
                        },
                        data: this.mapData,
                        // symbolSize: function (val) {
                        // 	return val[2] / 10;
                        // },
                        encode: {
                            value: 2
                        },
                        //标记
                        markPoint: {
                            symbol: 'circle',
                            itemStyle: {
                                // color: 'rgb(255,108,133)'
                                color: 'rgba(255,108,133,1)',
                                opacity: .5
                            },
							silent:true,
                            symbolSize: function (val, params) {
								let value=params.data.otherData;
                                if (value >= 100) {
                                    return 15
                                } else if(value==0){
                                    return 0
                                }else{
									return 10
								}
                            },
                            label: {
                                show: false
                            },
                            emphasis: {
                                label: {
                                    show: true
                                }
                            },
                            effect: {
                                show:false,
                                shadowBlur: 0
                            },
                            animation: true,
                            animationThreshold: 10,
                            data: dataInfoList
                        }
                    }]
                };
                this.chart.setOption(option);
                if (this.areaId == '0') {
                    this.top = '80px'
                } else {
                    this.top = '0px'
                }
            }
        },
        //地图点击事件
        chartClick(params) {
            // 点击标注区域进入地图下钻
            if (params.data.level == "street") return;
            this.cityName = params.data.name;
            this.cityCode = params.data.cityCode;
            this.mapAreaId = params.data.cityCode;
            this.district.setLevel(params.data.level); //行政区级别
            this.district.setExtensions("all");
            //行政区查询，按照adcode进行查询可以保证数据返回的唯一性
            this.district.search(this.cityCode, (status, result) => {
                if (status === "complete") {
                    let adcode = result.districtList[0].districtList[0].adcode;
                    //如果是直辖市（北京、天津、重庆、上海）还需要再检索一边 市=》城区=》区  与常规省=》市=》区 格式一致
                    if (
                        adcode == "110100" ||
                        adcode == "500100" ||
                        adcode == "500200" ||
                        adcode == "120100" ||
                        adcode == "310100"
                    ) {
                        this.district.search(adcode, (status, result) => {
                            if (status === "complete") {
                                this.getData(
                                    result.districtList[0],
                                    params.data.level,
                                    this.cityCode,
                                    "click"
                                );
                            }
                        });
						this.chartDbClick();
                    } else {
                        this.getData(
                            result.districtList[0],
                            params.data.level,
                            this.cityCode,
                            "click"
                        );
                    }
                }
            });
        },
        chartDbClick(e) {
			this.showAlert=false;
            let params = JSON.parse(JSON.stringify(this.MarksArray[this.MarksArray.length - 2]));
            let oldAdCode = params.adcode;
            this.mapAreaId = params.adcode;
            // 点击标注区域返回地图上级
            // 改变下拉框
            if (oldAdCode === '100000') {
                let newCode = 0;
                this.MarksArray.pop();
                this.initChart(oldAdCode);
                params.adcode = newCode.toString();
                this.$emit("clickMap", params, true);

            } else {
                this.MarksArray.pop();
                this.initChart(oldAdCode);
                params.adcode = this.getAreaCode(params.adcode,params.level);
                this.$emit("clickMap", params, true);
            }
        },
        chartMoveIn(e){
			this.nowCityCode=e.data.cityCode;
			this.level=e.data.level;
			this.nowAreaName=e.data.name;
		},
		chartMoveOut(e){
			this.showAlert=false
		},
		convertData(data) {
            var res = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].longitude && data[i].latitude) {
                    res.push({
                        name: data[i].areaName,
                        coord: [data[i].longitude, data[i].latitude],
                        otherData: data[i].num
                    });
                }
            }
            return res;
        },
		getAreaCode(code,level){
			console.log(level);
			if(level=='province'){
				return code.toString().slice(0,2)
			}else if(level=='city'){
				return code.toString().slice(0,4);
			}else if(level=='district'){
				return code.toString().slice(0,6)
			}
			// let re = '1';
			// for (let i = 0; i < code.length - 1; i++) {
			//     re += '0'
			// };
			// let m = (code / re);
			// let newRe = (code / re).toString().split('.')[1];
			// let ree = '1';
			// for (let i = 0; i < newRe.length; i++) {
			//     ree += '0'
			// };
			// let newCode = parseInt(m * ree);
			// return newCode.toString();
		},
		// clearZero(code,level){
		// 	console.log(level);
		// 	if(level=='province'){
		// 		return code.toString().slice(0,3)
		// 	}else if(level=='city'){
		// 		return code.toString().slice(0,5);
		// 	}else if(level=='district'){
		// 		return code.toString().slice(0,7)
		// 	}
		// 	// console.log(level);
		// 	// let re = '1';
		// 	// for (let i = 0; i < code.length - 1; i++) {
		// 	//     re += '0'
		// 	// };
		// 	// let m = (code / re);
		// 	// let newRe = (code / re).toString().split('.')[1];
		// 	// let ree = '1';
		// 	// for (let i = 0; i < newRe.length; i++) {
		// 	//     ree += '0'
		// 	// };
		// 	// let newCode = parseInt(m * ree);
		// 	// return newCode;
		// }
    }
};
</script>

<style lang="less" scoped>
.map-container {
    width: 100%;
    height: 100%;
    position: relative;
    // background: url("../assets/images/map_bg.png") no-repeat center;
    background-size: 100% 100%;
	.alertInfo{
		position: fixed;
		top: 20%;
		left: 30%;
		background: url(../../../assets/GIS/alert.png);
		width: 200px;
		height: auto;
		background-size: 100% 100%;
		padding: 10px;
		color: #fff;
		.name{
			margin-bottom: 10px;
			font-size: 20px;
		}
		.info{
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 14px;
			margin: 5px 0;
			span{
				&:nth-child(2){
					color: #28CFFF;
					font-weight: bold;
				}
			}
		}
	}
    .count {
        width: 222px;
        height: 128px;
        border-radius: 7px;
        border: 1px solid #1762f2;
        position: absolute;
        color: #fff;
        bottom: 2%;
        left: 2%;

        .title {
            font-size: 17px;
            height: 29px;
            line-height: 29px;
            background: #003294;
            line-height: 29px;
            text-align: center;
        }

        .main {
            height: 79px;
            padding-top: 10px;

            // border-top: none;
            font-size: 14px;

            img {
                width: 24px;
                height: 28px;
                float: left;
                vertical-align: middle;
                margin: 0 10px;
            }

            .org_name {
                float: left;
                height: 28px;
                line-height: 28px;
            }

            .num {
                float: right;
                line-height: 28px;
                margin-right: 10px;
            }
        }
    }
}
</style>
